<script>
    export default {
        props: {
            initConnectionTypeId: {
                type: Number,
                required: true
            },
        },
        data() {
            return {
                connectionTypeId: this.initConnectionTypeId,
                tablesList: [],
                tablesLoading: false,
            };
        },
        mounted() {
            this.loadTables();
        },
        watch: {
            connectionTypeId: function () {
                this.loadTables();
            }
        },
        methods: {
            loadTables() {
                this.tablesLoading = true;

                axios.get(route('metadata.dynamic-tables.list', {connectionTypeId: this.connectionTypeId})).then(response => {
                    this.tablesList = response.data;
                    this.tablesLoading = false;
                }).catch(() => {this.tablesLoading = false});
            },
            getTablesList() {
                return copy(this.tablesList);
            },
        }
    };
</script>
